/* FULLHED full-page hair-quiz controller.
   Intro -> 5 questions (grey step conditional) -> optional email -> a personalised
   plan (6 paths A-F) whose CTA adds the right variant + selling plan and opens the
   cart drawer. Emits fhTrack events + cart attributes + a Klaviyo identify/track. */
(function () {
  var root = document.querySelector('[data-fh-hq]');
  if (!root) return;

  function track() { return (window.fhTrack || function () {}).apply(null, arguments); }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[m]; }); }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
  function shopRoot() { return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'); }

  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-fh-hq-config]').textContent); } catch (e) {}
  var core = cfg.core || {}, kit = cfg.kit || {}, colors = cfg.colors || {};
  var coreImg = cfg.coreImg || '', kitImg = cfg.kitImg || coreImg;

  var progressBar = root.querySelector('[data-hq-progress]');
  var backBtn = root.querySelector('[data-hq-back]');
  var resultBox = root.querySelector('[data-hq-result]');
  var state = { tried: [] };
  var history = [];
  var advanceTimer = null;

  function stepEl(id) { return root.querySelector('[data-step="' + id + '"]'); }
  function show(id, record) {
    if (record !== false) { var cur = current(); if (cur && cur !== id) history.push(cur); }
    root.querySelectorAll('.fh-hq__step').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-step') === id); });
    var el = stepEl(id);
    var qn = el ? parseInt(el.getAttribute('data-qn'), 10) : 0;
    var pct = id === 'result' ? 100 : (qn ? Math.round(qn / 5 * 100) : (id === 'intro' ? 0 : 100));
    if (progressBar) progressBar.style.width = pct + '%';
    if (backBtn) backBtn.hidden = (id === 'intro' || id === 'result' || history.length === 0);
    try { window.scrollTo(0, 0); } catch (e) {}
  }
  function current() { var a = root.querySelector('.fh-hq__step.is-active'); return a ? a.getAttribute('data-step') : null; }

  // Sequence after each question (grey step only for solid colours)
  function nextAfter(id) {
    if (id === 'area') return 'time';
    if (id === 'time') return 'tried';
    if (id === 'tried') return 'shade';
    if (id === 'shade') {
      if (state.shade === 'mostlygrey') { state.grey = 'mostly'; return 'email'; }
      if (state.shade === 'greycoming') { state.grey = 'line'; return 'email'; }
      return 'grey';
    }
    if (id === 'grey') return 'email';
    return 'result';
  }

  // Intro start
  var startBtn = root.querySelector('[data-hq-start]');
  if (startBtn) startBtn.addEventListener('click', function () { track('fh_hairquiz_start', {}); show('area'); });

  // Back
  if (backBtn) backBtn.addEventListener('click', function () {
    clearTimeout(advanceTimer);
    var prev = history.pop();
    if (prev) show(prev, false);
  });

  // Single-select tiles/options auto-advance
  root.querySelectorAll('[data-q]:not([data-multi])').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var q = btn.dataset.q, v = btn.dataset.value;
      state[q] = v;
      var step = btn.closest('.fh-hq__step');
      step.querySelectorAll('[data-q]').forEach(function (b) { b.classList.remove('is-sel'); });
      btn.classList.add('is-sel');
      track('fh_hairquiz_answer', { question: q, answer: v });
      clearTimeout(advanceTimer);
      advanceTimer = setTimeout(function () { show(nextAfter(q)); }, 170);
    });
  });

  // Multi-select (tried)
  var triedStep = stepEl('tried');
  var continueBtn = triedStep && triedStep.querySelector('[data-hq-continue]');
  root.querySelectorAll('[data-q="tried"][data-multi]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = btn.dataset.value, i = state.tried.indexOf(v);
      if (i > -1) { state.tried.splice(i, 1); btn.classList.remove('is-sel'); }
      else { state.tried.push(v); btn.classList.add('is-sel'); }
      if (continueBtn) continueBtn.disabled = state.tried.length === 0;
    });
  });
  if (continueBtn) continueBtn.addEventListener('click', function () {
    track('fh_hairquiz_answer', { question: 'tried', answer: state.tried.join(',') });
    show(nextAfter('tried'));
  });

  // Email
  var emailInput = root.querySelector('[data-hq-email]');
  var emailGo = root.querySelector('[data-hq-email-continue]');
  var emailSkip = root.querySelector('[data-hq-email-skip]');
  if (emailGo) emailGo.addEventListener('click', function () {
    var v = (emailInput && emailInput.value || '').trim();
    if (!validEmail(v)) { if (emailInput) { emailInput.focus(); emailInput.classList.add('is-error'); } return; }
    try { localStorage.setItem('fh_email', v); } catch (e) {}
    sendKlaviyo(v);
    track('fh_hairquiz_email', { captured: true });
    finish();
  });
  if (emailSkip) emailSkip.addEventListener('click', function () { track('fh_hairquiz_email', { captured: false }); finish(); });

  function props() {
    return {
      area: state.area || '', duration: state.time || '',
      tried: (state.tried || []).join(', '), colour: state.shade || '', grey: state.grey || ''
    };
  }
  function sendKlaviyo(email) {
    try {
      window._learnq = window._learnq || [];
      var p = props(); p['$email'] = email; p.list = cfg.klaviyoList || 'hair-quiz';
      window._learnq.push(['identify', p]);
      window._learnq.push(['track', 'Hair Quiz Completed', props()]);
    } catch (e) {}
  }

  function resolveShade() {
    var v = state.shade;
    if (v === 'mostlygrey') return 'Grey Blend';
    if (v === 'greycoming') return 'Dark Brown';
    return v || 'Medium Brown';
  }

  function computeRec() {
    var tried = state.tried || [];
    var shade = resolveShade();
    if (tried.indexOf('fibers') > -1) return { type: 'C', shade: shade };
    if (state.shade === 'mostlygrey') return { type: 'E', shade: 'Grey Blend' };
    if (state.shade === 'greycoming' || state.grey === 'temples' || state.grey === 'saltpepper' || state.grey === 'line') {
      var base = shade === 'Grey Blend' ? 'Medium Brown' : shade;
      return { type: 'D', shade: base, second: 'Grey Blend' };
    }
    if (state.area === 'hairline') return { type: 'B', shade: shade };
    if (state.area === 'crown' && (state.time === 'new' || state.time === 'while')) return { type: 'A', shade: shade };
    if (state.area === 'everything' && state.time === 'years') return { type: 'F', shade: shade };
    return { type: 'S', shade: shade };
  }

  var GTEE = 'Fuller hair in your own mirror in 30 seconds, or your money back. 60 days, keep the bottle.';

  function planFor(rec) {
    var shade = rec.shade;
    switch (rec.type) {
      case 'A': return {
        head: 'Your spot: the crown. Your fix: 30 seconds.',
        advice: shade + ' fibers, and because the crown is where fibers work easiest, one bottle does it. Start with the Starter Kit: the precision applicator puts the fibers exactly on the spot instead of everywhere around it.',
        cardName: 'Starter Kit', cardShade: shade, price: 'A$64', img: kitImg,
        cta: 'Add my kit', tip: 'Apply to dry hair, two shakes, pat down. The crown forgives beginners.',
        items: kit[shade] ? [{ id: kit[shade], quantity: 1 }] : null };
      case 'B': return {
        head: 'The hairline needs precision. Good news: we sell precision.',
        advice: 'Edges are visible work. The Starter Kit with its precision applicator is not an upsell here, it is the difference between "done" and "done well".',
        cardName: 'Starter Kit', cardShade: shade, price: 'A$64', img: kitImg,
        cta: 'Add my kit', tip: 'Comb the hairline forward first, apply behind it, then style back. Sharper line, zero fallout on the forehead.',
        items: kit[shade] ? [{ id: kit[shade], quantity: 1 }] : null };
      case 'C': return {
        head: "You know fibers. You haven't met these.",
        advice: 'If your last fibers streaked in sweat or rain, that was dye-based powder. Colourfast mineral is the difference, and it is why we take the water test. The 3-pack with FULLHED3 (buy 2, get 1) is three months for the price of two, because when you know the concept you buy the stock, not the sample.',
        cardName: '3-pack', cardShade: shade, price: 'Buy 2, get 1 free', img: coreImg,
        cta: 'Add the 3-pack', tip: 'Less product than you used before. Colourfast fibers cover more per shake.',
        items: core[shade] ? [{ id: core[shade], quantity: 2 }, { id: core[shade], quantity: 1 }] : null };
      case 'D': return {
        head: 'The grey line, handled at home.',
        advice: shade + ' over the regrowth, or for salt and pepper a 2-pack: your main colour plus Grey Blend, mixed 70/30. What a barber does, but every morning in 30 seconds.',
        cardName: '2-pack', cardShade: shade + ' + Grey Blend', price: 'A$98', img: coreImg,
        cta: 'Add my shades', tip: 'Shake along the parting line only. Regrowth is a line, not a zone. One bottle lasts twice as long this way.',
        items: (core[shade] && core[rec.second]) ? [{ id: core[shade], quantity: 1 }, { id: core[rec.second], quantity: 1 }] : null };
      case 'E': return {
        head: 'Keep the silver. Fix the thin.',
        advice: 'Grey Blend or White fills the density without hiding the grey. Density and honesty are not opposites.',
        cardName: 'FULLHED Hair Fibers', cardShade: 'Grey Blend', price: 'A$49', img: coreImg,
        cta: 'Add my bottle', tip: 'White fibers on silver hair: start with one shake. It builds faster than you think.',
        items: core['Grey Blend'] ? [{ id: core['Grey Blend'], quantity: 1 }] : null };
      case 'F': return {
        head: 'All-over thinning: the subscription case.',
        advice: 'Spread-out thinning means daily use over a bigger area, so one bottle a month, structurally. The subscription (A$39, free shipping, skip, pause or cancel whenever) is simply the cheapest route here, not a sales trick.',
        cardName: 'Subscription', cardShade: shade, price: 'A$39 / 4 weeks', img: coreImg,
        cta: 'Start my subscription', tip: 'Section by section, back to front. Ninety seconds for full coverage, still faster than the kettle.',
        items: core[shade] ? [{ id: core[shade], quantity: 1, selling_plan: cfg.sellingPlanId || null }] : null };
      default: return {
        head: 'Your plan: ' + shade + ' fibers.',
        advice: 'One bottle in ' + shade + ', shaken over the thin areas, and you are full again in 30 seconds. Start here and add the applicator later if you want more control.',
        cardName: 'FULLHED Hair Fibers', cardShade: shade, price: 'A$49', img: coreImg,
        cta: 'Add my bottle', tip: 'Shake over the thin areas, pat once to settle, done in 30 seconds.',
        items: core[shade] ? [{ id: core[shade], quantity: 1 }] : null };
    }
  }

  function persist(rec) {
    var attrs = { 'Quiz area': state.area || '', 'Quiz duration': state.time || '', 'Quiz tried': (state.tried || []).join(', '), 'Quiz colour': state.shade || '', 'Quiz grey': state.grey || '', 'Quiz plan': rec.type, 'Quiz shade': rec.shade };
    try { localStorage.setItem('fh_hairquiz', JSON.stringify(state)); localStorage.setItem('fh_shade', rec.shade); } catch (e) {}
    try { fetch(shopRoot() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }); } catch (e) {}
  }

  function dot(shade) { return '<span class="fh-hq__resdot" style="background:' + (colors[shade] || '#333') + '"></span>'; }

  function finish() {
    clearTimeout(advanceTimer);
    var rec = computeRec();
    var plan = planFor(rec);
    persist(rec);
    track('fh_hairquiz_complete', { plan: rec.type, shade: rec.shade });
    show('result');
    var imgHtml = plan.img ? '<div class="fh-hq__card-photo"><img src="' + esc(plan.img) + '" alt="' + esc(plan.cardName) + '" width="200" height="200"></div>' : dot(rec.shade);
    resultBox.innerHTML =
      '<p class="fh-hq__kicker">Your plan</p>' +
      '<h2 class="fh-hq__q">' + esc(plan.head) + '</h2>' +
      '<p class="fh-hq__tagline">' + esc(plan.advice) + '</p>' +
      '<div class="fh-hq__card">' +
        '<div class="fh-hq__card-head">' + imgHtml +
          '<div class="fh-hq__card-meta"><span class="fh-hq__card-name">' + esc(plan.cardName) + '</span>' +
          '<span class="fh-hq__card-shade">Shade: ' + esc(plan.cardShade) + '</span></div>' +
          '<span class="fh-hq__card-price">' + esc(plan.price) + '</span>' +
        '</div>' +
        '<p class="fh-hq__card-tip"><strong>Tip:</strong> ' + esc(plan.tip) + '</p>' +
        '<p class="fh-hq__card-gtee">' + esc(GTEE) + '</p>' +
        '<button type="button" class="fh-btn fh-btn--primary fh-btn--block fh-btn--lg" data-hq-buy data-fh-prelander-cta data-angle="hair-quiz" data-loc="plan">' + esc(plan.cta) + '</button>' +
      '</div>' +
      '<a class="fh-hq__readmore" href="' + esc(cfg.readMoreUrl || '/') + '">Not ready? Read how it works &rarr;</a>';

    var buy = resultBox.querySelector('[data-hq-buy]');
    if (buy) buy.addEventListener('click', function () {
      if (!plan.items) { window.location.href = cfg.productUrl || '/products/fullhed-hair-fibers'; return; }
      track('fh_hairquiz_cta', { plan: rec.type, shade: rec.shade });
      buy.disabled = true;
      fetch(shopRoot() + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: plan.items.map(function (i) { return { id: i.id, quantity: i.quantity, selling_plan: i.selling_plan || null }; }) })
      }).then(function () {
        if (window.fhCart && window.fhCart.open) window.fhCart.open();
        else window.location.href = cfg.cartUrl || '/cart';
      }).catch(function () { buy.disabled = false; window.location.href = cfg.cartUrl || '/cart'; });
    });
  }
})();
